import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Utility } from '@app/models/utility';
import { Define } from '@app/models/define';
import { ReportRecord } from '@app/models/report';
import { MatDialog } from '@angular/material/dialog';
import { RequestDialogComponent } from '../request-dialog/request-dialog.component';
import { DateDetailDialogComponent } from '../date-detail-dialog/date-detail-dialog.component';
import { ShiftStampDialogComponent } from '../shift-stamp-dialog/shift-stamp-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface StampSet {
  stamp: Date;
  dateText: string;
  ejectFlag: boolean;
  shiftEditable: boolean;
}

@Component({
  selector: 'app-own-histories-detail',
  templateUrl: './own-histories-detail.component.html',
  styleUrls: ['./own-histories-detail.component.css']
})
export class OwnHistoriesDetailComponent implements OnInit {
  @Input() reportRecord: ReportRecord;
  @Output() update = new EventEmitter(true);
  toggle = false;
  reportDate: StampSet[][] = [[], [], [], []];
  report = new Array<string>(4).fill('-');
  request = new Array<string>(4).fill('-');
  statusIcon = ['hourglass_empty', 'check', 'clear'];
  statusTitle = ['申請中', '承認済み', '申請却下'];
  status = -1;
  detailStatus = '';
  ejectFlags = new Array<boolean>(10).fill(false);
  canShiftEdit = false;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    const dateDiff = ['前', '', '翌'];
    if (this.reportRecord.sourceStamps !== undefined) {
      if (this.reportRecord.sourceStamps.length !== 0) {
        this.canShiftEdit = true;
        this.reportRecord.sourceStamps.forEach( timeStamp => {
          const dateDiffIndex =  Utility.diffDay(this.reportRecord.date, timeStamp.stamp) + 1;
          if (this.report[timeStamp.kind] === '-') {
            this.report[timeStamp.kind] = dateDiff[dateDiffIndex] + Utility.convertDateToMinite(timeStamp.stamp);
          } else {
            this.report[timeStamp.kind] += '\n' + dateDiff[dateDiffIndex] + Utility.convertDateToMinite(timeStamp.stamp);
          }
          this.reportDate[timeStamp.kind].push({
            stamp: timeStamp.stamp,
            dateText: dateDiff[dateDiffIndex] + Utility.convertDateToMinite(timeStamp.stamp),
            ejectFlag: false,
            shiftEditable: true
          });
        });
      }
    }
    if (this.reportRecord.request !== undefined) {
      this.status = this.reportRecord.request.state;

      if (this.status === Define.RequestState.Registered) {
        this.canShiftEdit = false;
      }

      this.detailStatus = this.reportRecord.getState(true);
      this.ejectFlags = this.reportRecord.request.ejectFlags.slice();

      this.ejectFlags.forEach((e, index) => {
        if (e) {
          // 取消なら
          if (index === 0 || index === 1) {
            // 出社・退社
            // 現状出社・退社の実打刻取消は出来ない
          } else if (index % 2 === 0) {
            // 外出
            if (this.reportDate[2][Math.round((index - 2) / 2)]) {
              this.reportDate[2][Math.round((index - 2) / 2)].ejectFlag = true;
              if (this.status === Define.RequestState.Approve) {
                this.reportDate[2][Math.round((index - 2) / 2)].shiftEditable = false;
              }
            }
          } else if (index % 2 === 1) {
            // 戻り
            if (this.reportDate[3][Math.round((index - 3) / 2)]) {
              this.reportDate[3][Math.round((index - 3) / 2)].ejectFlag = true;
              if (this.status === Define.RequestState.Approve) {
                this.reportDate[3][Math.round((index - 3) / 2)].shiftEditable = false;
              }
            }
          }
        }

        if (this.status === Define.RequestState.Registered) {
          // 取消申請に依存せず申請中はふりわけ出来なくする
          if (index === 0 || index === 1) {
            // 出社・退社
            // 現状出社・退社の実打刻取消は出来ない
          } else if (index % 2 === 0) {
            // 外出
            if (this.reportDate[2][Math.round((index - 2) / 2)] !== undefined) {
              this.reportDate[2][Math.round((index - 2) / 2)].shiftEditable = false;
            }
          } else if (index % 2 === 1) {
            // 戻り
            if (this.reportDate[3][Math.round((index - 3) / 2)] !== undefined) {
            this.reportDate[3][Math.round((index - 3) / 2)].shiftEditable = false;
            }
          }
        }
      });

      this.reportRecord.request.changeStamps.forEach( (timeStamp, index) => {
        if (timeStamp !== null) {
          // firestoreのchangeStampには日本時間に合わせることで現地時間となるtimestampを記録している。
          const jstDate = Utility.convertLocalTimeToJstDate(timeStamp.toDate());
          const dateDiffIndex =  Utility.diffDay(this.reportRecord.date, jstDate) + 1;
          if (index === 0 || index === 1) {
            // 出社 退社
            if (this.request[index] === '-') {
              this.request[index] = dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            } else {
              this.request[index] += '\n' + dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            }
          } else if (index % 2 === 0) {
            // 外出
            if (this.request[2] === '-') {
              this.request[2] = dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            } else {
              this.request[2] += '\n' + dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            }
          } else if (index % 2 === 1) {
            // 戻り
            if (this.request[3] === '-') {
              this.request[3] = dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            } else {
              this.request[3] += '\n' + dateDiff[dateDiffIndex] + Utility.convertDateToMinite(jstDate);
            }
          }

        }
      });
    }
  }

  openDialog(row: ReportRecord) {
    console.log(`openDialog date:${row.date}`);

    console.log('foo');
    console.log(row.sourceStamps);

    if (row.date === undefined) {
      console.log('openDialog invalid data.');
      return;
    }
    console.log(`openDialog open`);

    const dialogRef = this.dialog.open(RequestDialogComponent, { data: { row: row }, maxWidth: '95vw'});
    dialogRef.afterClosed().subscribe(result => {
      console.log(`dialog close. result:${result}`);
      if (result) {
        // 親要素のupdate()で表示リフレッシュ
        this.update.emit();
      }
    });
  }

  isSaturday(row: ReportRecord) {
    return row.date.getDay() === 6;
  }

  isSunday(row: ReportRecord) {
    return row.date.getDay() === 0;
  }

  showDateInfo(row: ReportRecord) {
    this.dialog.open(DateDetailDialogComponent, { data: { data: row } });
  }

  openShiftStampDialog(row: ReportRecord, stamp: Date) {
    const dialogRef = this.dialog.open(ShiftStampDialogComponent, { data: { record: row, stamp: stamp} });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`dialog close. result:${result}`);
      if (result) {
        // 親要素のupdate()で表示リフレッシュ
        this.update.emit();
      }
    });
  }

  onEjectedStamp() {
    if (this.status === Define.RequestState.Registered) {
      this._snackBar.open('申請中はふりわけ変更出来ません。', 'OK');
    } else {
      this._snackBar.open('取消を申請した打刻はふりわけ変更出来ません。', 'OK');
    }
  }
}
